import * as categories from './categories'

export default categories
